import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TransporterClientScreen from './Components/TransporterClientScreen';

const RouterOutlet = () => (
  <Routes>
    <Route path="/" element={<TransporterClientScreen />} />
    <Route path="/profile" element={<TransporterClientScreen />} />
    <Route path="/profile/:name" element={<TransporterClientScreen />} />
  </Routes>
);

export default RouterOutlet;
